import store from './store.js';
import axios from 'axios';
import * as qs from 'qs'

// Generic API request helper
const apiRequest = async ({ method, url, headers, data = null }) => {
  try {
    const config = { method, url, headers };
    if (data) config.data = data;
    const res = await axios(config);
    return res.data;
  } catch (err) {
    if (err.response) console.dir(err.response);
    else console.dir(err);
    return false;
  }
};

const getApiBaseUrl = () => {
  return store.apiBaseUrl || '';
};

const getAuthHeaders = (_isUrlencoded) => {
  return {
    accept: "application/json",
    "Content-Type": _isUrlencoded ? "application/x-www-form-urlencoded" : "application/json",
    "Authorization": `Bearer ${store.user.access_token}`
  }
}

const login = async (_user, _pass) => {
  var apiLoginData = qs.stringify({
    grant_type: "password",
    username: _user,
    password: _pass,
    client_secret: "secret_for_randomstate_customer",
    usertype: "Customer",
    client_id: "randomstate_customer",
    scope: "randomstate_customer offline_access"
  });

  var config = {
    method: "post",
    url: getApiBaseUrl() + "/connect/token",
    headers: {
        "Content-Type": "application/x-www-form-urlencoded"
    },
    data: apiLoginData
  };

  let response = await axios(config);

  store.user = {
    username: _user,
    access_token: response.data.access_token,
    refresh_token: response.data.refresh_token,
    balance: { total: null, money: null, bonus: null, goods: null }
  };
  store.page = 'loggedin';
  try {
    const clientConfig = await getClientConfig();
    if (clientConfig) store.clientConfig = clientConfig;
  } catch (e) {
    console.log('Failed to fetch client config', e);
  }
  updateBalance();
  return true;
};

const getClientConfig = async () => {
  return await apiRequest({
    method: "GET",
    url: getApiBaseUrl() + "/api/GameClientConfig",
    headers: getAuthHeaders(false)
  });
};

const transactions = async (pageNumber, pageSize) => {
  const data = await apiRequest({
    method: "GET",
    url: getApiBaseUrl() + `/api/CustomerTransaction?pageNumber=${pageNumber}&pageSize=${pageSize}`,
    headers: getAuthHeaders(true)
  });
  if (data) store.user.transactions = data;
  return data;
};

const updateBalance = async () => {
  const data = await apiRequest({
    method: "GET",
    url: getApiBaseUrl() + "/api/CustomerTransaction/CombinedBalance",
    headers: getAuthHeaders(true)
  });

  if (!data) {
    return false;
  }

  store.user.balance = {
    total: data.totalValue,
    money: data.moneyValue,
    goods: data.goodsValue,
    bonus: data.bonusValue
  };

  return true;
};

const getUnfinishedTickets = async (_gameCollectionId) => {
  return await apiRequest({
    method: "POST",
    url: getApiBaseUrl() + "/api/Game/GetUnfinishedTickets",
    headers: getAuthHeaders(false),
    data: {
      gameId: _gameCollectionId,
      channel: "",
      additionalData: "",
    }
  });
};

const buyGameCollection = async (_gameCollectionId, _buyArguments) => {
  const payload = {
    gameId: _gameCollectionId,
    channel: "test",
    additionalData: "test",
  };
  if (_buyArguments) payload.buyArguments = _buyArguments;
  return await apiRequest({
    method: "PUT",
    url: getApiBaseUrl() + "/api/Game",
    headers: getAuthHeaders(false),
    data: payload
  });
};

const finalizeGameTicket = async (_verb, gameType, _ticketId) => {
  return await apiRequest({
    method: _verb,
    url: getApiBaseUrl() + "/api/Game/finalizeTicket?gameType=" + gameType + "&ticketId=" + _ticketId,
    headers: getAuthHeaders(false)
  });
};

const finalizeGameWithCorrelationId = async (_correlationId) => {
  return await apiRequest({
    method: 'PUT',
    url: getApiBaseUrl() + "/api/Game/finalizeGameCollection/" + _correlationId,
    headers: getAuthHeaders(false)
  });
};

const getRaffleInfo = async (_raffleId) => {
  return await apiRequest({
    method: "GET",
    url: getApiBaseUrl() + "/api/Raffles/" + _raffleId,
    headers: getAuthHeaders(false)
  });
};

const getMyRaffleTicketsInRound = async (_raffleRoundId) => {
  return await apiRequest({
    method: "GET",
    url: getApiBaseUrl() + "/api/Raffles/"+_raffleRoundId+'/MyNumbers',
    headers: getAuthHeaders(false)
  });
};

const getRaffleRounds = async (_raffleId) => {
  return await apiRequest({
    method: "GET",
    url: getApiBaseUrl() + "/api/Raffles/"+_raffleId+'/Rounds',
    headers: getAuthHeaders(false)
  });
};

const getMyRaffleRoundResults = async (_raffleId, _roundId) => {
  return await apiRequest({
    method: "GET",
    url: getApiBaseUrl() + "/api/Raffles/" + _raffleId + '/MyResults/' + _roundId,
    headers: getAuthHeaders(false)
  });
};

const getJackpotTicket = async (_ticketId) => {
  return await apiRequest({
    method: "GET",
    url: getApiBaseUrl() + "/api/jackpot/Tickets/" + _ticketId,
    headers: getAuthHeaders(false)
  });
};

const getInstantTicket = async (_ticketId) => {
  return await apiRequest({
    method: "GET",
    url: getApiBaseUrl() + "/api/Instant/Tickets/" + _ticketId,
    headers: getAuthHeaders(false)
  });
};

const getLottoTicket = async (_ticketId) => {
  return await apiRequest({
    method: "GET",
    url: getApiBaseUrl() + "/api/Lotto/Tickets/" + _ticketId,
    headers: getAuthHeaders(false)
  });
};

const getLatestLottoTickets = async (latestRoundCount = 10) => {
  const url = `${getApiBaseUrl()}/api/Lotto?latestRoundCount=${latestRoundCount}`;
  return await apiRequest({
    method: "GET",
    url: url,
    headers: getAuthHeaders(false)
  });
};

const getLottoRounds = async (_lottoId) => {
  return await apiRequest({
    method: "GET",
    url: getApiBaseUrl() + "/api/Lotto/" + _lottoId + "/rounds/open",
    headers: getAuthHeaders(false)
  });
};

const getLottoGame = async (_lottoId) => {
  return await apiRequest({
    method: "GET",
    url: getApiBaseUrl() + "/api/Lotto/" + _lottoId,
    headers: getAuthHeaders(false)
  });
};

const getWinLoseTicket = async (_ticketId) => {
  return await apiRequest({
    method: "GET",
    url: getApiBaseUrl() + "/api/winlose/Tickets/" + _ticketId,
    headers: getAuthHeaders(false)
  });
};

const getProbabilityTicket = async (_ticketId) => {
  return await apiRequest({
    method: "GET",
    url: getApiBaseUrl() + "/api/probability/Tickets/" + _ticketId,
    headers: getAuthHeaders(false)
  });
};

const pickProbabilityNumber = async (_ticketId, number) => {
  return await apiRequest({
    method: "POST",
    url: getApiBaseUrl() + "/api/probability/Tickets/" + _ticketId + "/picks/" + number,
    headers: getAuthHeaders(false)
  });
};

const probabilityCashOut = async (_ticketId) => {
  return await apiRequest({
    method: "POST",
    url: getApiBaseUrl() + "/api/probability/Tickets/" + _ticketId + "/cashouts",
    headers: getAuthHeaders(false)
  });
};

const getCashoutTicket = async (_ticketId) => {
  return await apiRequest({
    method: "GET",
    url: getApiBaseUrl() + "/api/CashOut/Tickets/" + _ticketId,
    headers: getAuthHeaders(false)
  });
};

const getCashoutTicketInfo = async (_ticketId) => {
  return await apiRequest({
    method: "GET",
    url: getApiBaseUrl() + "/api/CashOut/Tickets/" + _ticketId + "/Info",
    headers: getAuthHeaders(false)
  });
};

const continueCashoutLevel = async (_ticketId) => {
  return await apiRequest({
    method: "POST",
    url: getApiBaseUrl() + "/api/CashOut/Tickets/" + _ticketId + "/continue",
    headers: getAuthHeaders(false)
  });
};

const getCrashTicketByGuid = async (_ticketGuid) => {
  return await apiRequest({
    method: "GET",
    url: getApiBaseUrl() + "/api/Crash/Tickets/" + _ticketGuid,
    headers: getAuthHeaders(false)
  });
};

const getCrashConfig = async (_pluginGameId) => {
  return await apiRequest({
    method: "GET",
    url: getApiBaseUrl() + "/api/CrashAdmin/" + _pluginGameId,
    headers: getAuthHeaders(false)
  });
};

export {
  login,
  updateBalance,
  getUnfinishedTickets,
  buyGameCollection,
  finalizeGameTicket,
  finalizeGameWithCorrelationId,
  getRaffleInfo,
  getMyRaffleTicketsInRound,
  getRaffleRounds,
  getMyRaffleRoundResults,
  getJackpotTicket,
  getInstantTicket,
  getLottoTicket,
  getLottoRounds,
  getLottoGame,
  transactions,
  getWinLoseTicket,
  getProbabilityTicket,
  pickProbabilityNumber,
  probabilityCashOut,
  getCashoutTicket,
  getCashoutTicketInfo,
  continueCashoutLevel,
  getLatestLottoTickets,
  getClientConfig,
  getCrashTicketByGuid,
  getCrashConfig
};